module.exports = {
      id: "icon-notepad-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-notepad",
      toString: function () {
        return this.url;
      }
    }